import React from 'react';
import PropTypes from 'prop-types';

import { Tab, Tabs } from 'react-bootstrap';

import CustomFieldsConfig from 'bundles/apex/custom_fields/config';
import PlaybooksConfig from 'bundles/apex/playbooks/config';

export default function ApexSettings({ customFieldsConfigProps, playbooksConfigProps }) {
  if (!customFieldsConfigProps) {
    return <PlaybooksConfig {...playbooksConfigProps} />;
  }

  return (
    <Tabs defaultActiveKey="playbooks" id="apex-settings" unmountOnExit>
      <Tab className="mt-3" eventKey="playbooks" title="Deals">
        <PlaybooksConfig {...playbooksConfigProps} />
      </Tab>
      <Tab className="mt-3" eventKey="customFields" title="Custom Fields">
        <CustomFieldsConfig {...customFieldsConfigProps} />
      </Tab>
    </Tabs>
  );
}

ApexSettings.propTypes = {
  customFieldsConfigProps: PropTypes.object,
  playbooksConfigProps: PropTypes.object,
};
